import React from 'react'
import AdBlockAlert from '../common/AdBlockAlert'
import GlobalNavigation from './GlobalNavigation'

const Layout = ({ children }) => {
  return (
    <div className="min-h-screen bg-white" style={{ backgroundColor: '#FFFFFF' }}>
      <AdBlockAlert />
      <GlobalNavigation />
      <main className="w-full max-w-6xl mx-auto px-3 xs-370:px-4 pt-4 pb-24 md:pb-8">
        {children}
      </main>
    </div>
  )
}

export default Layout